module.exports = __webpack_public_path__ + "static/licence-2b6e4c370878f5df9c80b36dfa2a662d.png";